export const NOTE_CONSTS = {
	GET_NOTES: "GET_NOTES",
	CHANGE_API_STATUS_GET_NOTES: "CHANGE_API_STATUS_GET_NOTES",
	UPDATE_FILTERS: "UPDATE_FILTERS",
	RESET_FILTERS: "RESET_FILTERS",
};